import { useState, useEffect } from "react";

export const useSequentialAnimation = ({ 
    isReady = false,
    shouldReset = false,
    animations = [],
    skipFirst = false 
}) => {
    const [visibleItems, setVisibleItems] = useState([]);

    useEffect(() => {
        if (!isReady || shouldReset) {
            setVisibleItems([]);
            return;
        }

        const timers = [];
        let cumulativeDelay = 0;
        
        const startIndex = skipFirst ? 1 : 0;
        
        animations.forEach((animation, index) => {
            if (index < startIndex) {
                setVisibleItems(prev => [...prev.filter(i => i !== index), index]);
                return;
            }

            const delay = index === startIndex ? cumulativeDelay : cumulativeDelay + (animation.bufferDelay || 0);
            
            const timer = setTimeout(() => {
                setVisibleItems(prev => [...prev.filter(i => i !== index), index]);
            }, delay);
            
            timers.push(timer);
            
            if (animation.duration) {
                cumulativeDelay = delay + animation.duration;
            } else if (animation.text && animation.speed) {
                const textDuration = (animation.text.length * animation.speed) / animation.text.length;
                cumulativeDelay = delay + textDuration;
            }
        });

        return () => {
            timers.forEach(timer => clearTimeout(timer));
        };
    }, [isReady, shouldReset, skipFirst, animations]);

    const isVisible = (index) => visibleItems.includes(index);

    return {
        visibleItems,
        isVisible
    };
}; 